// Table
export const S_LAG_HEADER = 'S-Lag';
export const WEB_HEADER = 'Stemmesedler fra web';
export const STAND_HEADER = 'Stemmesedler fra stand';
export const TOTAL_LABEL = 'Total for alle S-lag';
